export default String.raw`.card-product__image{height:234px}`